export default __webpack_public_path__ + "static/media/galarie4.02a0cba7.jpg";